import hoistNonReactStatics from 'hoist-non-react-statics';
import coinUniversal from '@nerdwallet/coin/universal';

// We need to hoist the non-React static `getEditingConfig` method for our
// code-split components because nw-app-module/universal does not do this
// at the right time for HOC-wrapped components.
// See https://github.com/NerdWallet/nwjs-structured-content-core/blob/00fa73bd1082a50053770537ab34b12411ac2c25/src/context/components-store.js#L40-L71
// and also https://github.com/NerdWallet/nw-app-module/blob/1a87c1c6e6b159df32beefd4a4e458e6a135554a/src/codesplit/universal.js#L6-L43
const universal = (asyncImport) => {
  const UniversalComponent = coinUniversal(asyncImport, {
    onLoad: (module) => {
      hoistNonReactStatics(UniversalComponent, module.default);
    },
  });

  return UniversalComponent;
};

export default universal;
